import { db } from '@/db';
import {
  collection,
  deleteDoc,
  doc,
  getDocs,
  onSnapshot,
  orderBy,
  query,
  updateDoc,
} from 'firebase/firestore';

export const notifications = {
  namespaced: true,
  state: () => ({
    list: [],
    unreadCount: 0,
  }),
  mutations: {
    setAll(state, data) {
      state.list = data;
      state.unreadCount = data.filter((n) => !n.isRead).length;
    },
    markAllRead(state) {
      state.list.forEach((n) => (n.isRead = true));
      state.unreadCount = 0;
    },
  },
  actions: {
    listen({ commit, rootState }) {
      // Add null check for user authentication
      if (!rootState.auth.user || !rootState.auth.user.id) {
        console.log('Notifications: User not authenticated, skipping listener setup');
        return;
      }

      const userId = rootState.auth.user.id.toString();
      const notifRef = collection(db, userId, 'notifications', 'listing');
      const q = query(notifRef, orderBy('date', 'desc'));

      onSnapshot(q, (snapshot) => {
        const all = snapshot.docs.map((doc) => ({
          docId: doc.id, // Firestore doc ID for updates/removes
          ...doc.data(), // Your app data (including id, title, etc.)
        }));
        commit('setAll', all);
      });
    },
    async clear({ commit, rootState }) {
      // Add null check for user authentication
      if (!rootState.auth.user || !rootState.auth.user.id) {
        console.log('Notifications: User not authenticated, skipping clear action');
        return;
      }

      const userId = rootState.auth.user.id.toString();
      const notifRef = collection(db, userId, 'notifications', 'listing');

      const snapshot = await getDocs(notifRef);
      for (const docSnap of snapshot.docs) {
        await updateDoc(doc(db, userId, 'notifications', 'listing', docSnap.id), {
          isRead: true,
        });
      }

      commit('markAllRead');
    },
    // async markAsRead({ rootState }, notifId) {
    //   const userId = rootState.auth.user.id.toString();
    //   const notifRef = doc(db, userId, "notifications", "listing", notifId);
    //   await updateDoc(notifRef, { isRead: true });
    // },

    async markAsRead({ rootState }, notifId) {
      if (!notifId) return;

      // Add null check for user authentication
      if (!rootState.auth.user || !rootState.auth.user.id) {
        console.log('Notifications: User not authenticated, skipping markAsRead action');
        return;
      }

      const userId = rootState.auth.user.id;
      const notifRef = doc(db, String(userId), 'notifications', 'listing', String(notifId));
      await updateDoc(notifRef, { isRead: true });
    },

    async remove({ commit, rootState }, notifId) {
      // Add null check for user authentication
      if (!rootState.auth.user || !rootState.auth.user.id) {
        console.log('Notifications: User not authenticated, skipping remove action');
        return;
      }

      const userId = rootState.auth.user.id.toString();
      const notifRef = doc(db, userId, 'notifications', 'listing', notifId);
      await deleteDoc(notifRef);
    },
  },
  getters: {
    unreadCount: (s) => s.unreadCount,
    all: (s) => s.list,
  },
};
